/**
 * Created by zzy on 2019/8/8.
 */
import AppTreeSide from './AppTreeSide.vue'
export default AppTreeSide



// WEBPACK FOOTER //
// ./src/components/appTreeSide/index.js